import { firebaseAction } from 'vuexfire'
import l from '@/vendor/logger'
import { db } from '@/store'
import { DB_TIMESTAMP } from '@/vendor/firebase'
import * as _ from 'ramda'
import { bannedWatchersUrl } from '@/config'

const state = {
  bannedWatchers: {},
  filteringWords: {},
  chatCss: {}
}

const getters = {
  watchers (state) {
    return '.value' in state.bannedWatchers
      ? ''
      : _.omit(['.key'], state.bannedWatchers)
  },
  words (state) {
    return '.value' in state.filteringWords
      ? state.filteringWords['.value']
      : ''
  },
  filteringWords (state) {
    return '.value' in state.filteringWords
      ? state.filteringWords['.value'].split(',')
      : []
  },
  chatCss (state) {
    return '.value' in state.chatCss
      ? state.chatCss['.value']
      : ''
  }
}

const mutations = {

}

const actions = {
  bindBannedWatchers: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('bannedWatchers', db.ref('bannedWatchers'))
  }),

  unbindBannedWatchers: firebaseAction(({ unbindFirebaseRef, rootState, commit }) => {
    unbindFirebaseRef('bannedWatchers', db.ref('bannedWatchers'))
    db.ref(`bannedWatchers`).off()
  }),

  bindFilteringWords: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('filteringWords', db.ref('filteringWords'))
  }),

  unbindFilteringWords: firebaseAction(({ unbindFirebaseRef, rootState }) => {
    unbindFirebaseRef('filteringWords', db.ref('filteringWords'))
    db.ref(`filteringWords`).off()
  }),

  bindChatCss: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('chatCss', db.ref('chatCss'))
  }),

  unbindChatCss: firebaseAction(({ unbindFirebaseRef, rootState }) => {
    unbindFirebaseRef('chatCss', db.ref('chatCss'))
    db.ref(`chatCss`).off()
  }),

  async addWatcher ({ commit, state, rootState }, { uid, nickname, message, reason }) {
    if (reason === undefined) {
      reason = '넌 그냥 안돼'
    }
    l.d('add bannedWatchers', uid, nickname, message, reason, rootState.rid)
    try {
      await db.ref(`chatOption/${uid}`)
        .set({
          id: uid,
          nickname,
          message,
          reason,
          roomId: rootState.rid,
          bannedAt: DB_TIMESTAMP
        })
    } catch (err) {
      l.e(`chatOption/addWatcher`, err)
    }
  },

  async removeWatcher ({ commit, state, rootState }, uid) {
    l.d('chatOption/removeWatchers', uid)
    try {
      await db.ref(`chatOption/${uid}`).remove()
    } catch (err) {
      l.e(`chatOption/removeWatcher`, err)
    }
  },

  async getFiltersWord ({ commit, state, rootState }) {
    l.d('chatOption/getFiltersWord')
    let headers = new Headers()
    headers.append('token', rootState.userToken)
    fetch(`${bannedWatchersUrl}?db=product`,
      {
        method: 'GET',
        headers,
        mode: 'cors'
      }).then((response) => {
      if (response.ok) {
        l.d('chatOption/getFiltersWord', response)
      } else {
        l.e('chatOption/getFiltersWord', response)
      }
    })
  },

  async setFiltersWord ({ commit, state, rootState }, { filters, mode }) {
    l.d('chatOption/setFiltersWord', filters, mode)
    let headers = new Headers()
    headers.append('token', rootState.userToken)
    fetch(`${bannedWatchersUrl}?db=${mode.toLowerCase()}`,
      {
        method: 'PUT',
        headers,
        mode: 'cors',
        body: filters
      }).then((response) => {
      if (response.ok) {
        l.d('setFiltersWord', response)
      } else {
        l.e('setFiltersWord', response)
      }
    })
  },

  async setChatCss ({ commit, state, rootState }, css) {
    l.d(`chatOption/setChatCss`, css)
    try {
      await db.ref(`chatCss`).set(css)
    } catch (err) {
      l.e('chatOption/createRoom', err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
